import TokenCards from 'components/cards/token-cards';

const BalancesPage = () => {
  return <TokenCards />;
};

export default BalancesPage;
